<div>
  <div *ngIf="hasFilter" class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body ">
          <div class="row d-flex align-items-center">
            <div class="col-lg-6">
              <div class="d-flex align-items-center">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <label class="input-group-text" for="inizio" [translate]="'ordini.inizio'">Inizio</label>
                  </div>
                  <input [(ngModel)]="filtri.inizio" type="date" name="inizio" class="form-control">
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="d-flex align-items-center">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <label class="input-group-text" for="fine" [translate]="'ordini.fine'">Fine</label>
                  </div>
                  <input [(ngModel)]="filtri.fine" type="date" name="fine" class="form-control">
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <div>
                        <input [(ngModel)]="filtri.periodo" type="checkbox" id="periodo">
                        <label for="periodo"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="cliente" class="control-label col-form-label" [translate]="'ordini.cliente'">Cliente</label>
                <input id="cliente" [(ngModel)]="filtri.cliente" class="form-control" type="text">
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="prodotto" class="control-label col-form-label"
                  [translate]="'ordini.prodotto'">Prodotto</label>
                <input id="prodotto" [(ngModel)]="filtri.prodotto" class="form-control" type="text">
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="ordine" class="control-label col-form-label">Ordine</label>
                <input id="ordine" [(ngModel)]="filtri.ordine" class="form-control" type="text">
              </div>
            </div>
            <div class="col-sm-12 col-md-2 p-t-0 p-b-0 p-r-5 p-l-5 d-flex align-items-end">
              <ng-template #tipContentss>
                <div class="row" *ngFor="let element of Best">
                  <span class="px-3 font-14">{{element.voce}}&nbsp; {{element.qta}} Pz</span>
                  <a href="javascript:void(0)" [cdkCopyToClipboard]="element.voce"
                    class="link text-orange font-16 font-weight-bold" (click)="p1.close()">
                    <i class="fas fa-copy"></i> &nbsp;
                  </a>
                </div>
              </ng-template>
              <button type="button" class="btn btn-secondary" [ngbPopover]="tipContentss" [autoClose]="'outside'"
                triggers="manual" placement="bottom" #p1="ngbPopover" popoverTitle="Articoli Top" (click)="p1.open()">
                Articoli Top
              </button>
            </div>
            <div class="col-sm-12"></div>
            <div class="col-sm-12 col-lg-3">
              <div *ngIf="TipiCliente" class="">
                <label class="control-label col-form-label"> Tipi Cliente</label>
                <ng-multiselect-dropdown [settings]="ClassicType.GetMultipleDropdownSettings()"
                  [disabled]="!isModifyEnabled" [placeholder]="'Seleziona'" [data]="TipiCliente"
                  [(ngModel)]="filtri.tipiClienteSelezionati">
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="col-sm-12 col-md-3 p-t-0 p-b-0 p-r-5 p-l-5">
              <label for="stato" class="control-label col-form-label">Stato:</label>
              <ng-multiselect-dropdown #stato="ngModel" [settings]="dropdownSettings" [placeholder]="'Seleziona'"
                id="stato" name="stato" [data]="stati" [(ngModel)]="statiSelezionati" (ngModelChange)="StateChanged()">
              </ng-multiselect-dropdown>
              <small class="form-text text-danger" *ngIf="!stato.valid && (stato.dirty || stato.touched)">Stato
                richiesto!</small>
            </div>
            <!-- <div class="col-sm-12 col-md-3 p-t-0 p-b-0 p-r-5 p-l-5">
              <label for="color" class="control-label col-form-label">Colore:</label>
              <ng-multiselect-dropdown [settings]="filterdropdownSettings" [placeholder]="'Seleziona'" id="color" name="color" [data]="Colori" [(ngModel)]="ColoriSelezionati" >
              </ng-multiselect-dropdown>
            </div>
            <div class="col-sm-12 col-md-3 p-t-0 p-b-0 p-r-5 p-l-5">
              <label for="materiale" class="control-label col-form-label">Materiale:</label>
              <ng-multiselect-dropdown [settings]="filterdropdownSettings" [placeholder]="'Seleziona'" id="materiale" name="materiale" [data]="Materiali" [(ngModel)]="MaterialiSelezionati" >
              </ng-multiselect-dropdown>
            </div>-->
            <div class="col-lg-3 m-t-30">
              <button type="button" class="btn btn-info rounded-pill py-2" (click)='refreshTable(1)'>
                <i class="fas fa-search font-14 mr-1 text-white"></i>
                <span class="ml-1 text-white font-weight-bold">Cerca</span>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="hasHeader" class="d-md-flex align-items-center bg-white p-3">
    <a href="javascript:void(0)" class="d-flex align-items-center p-2 rounded-pill bg-light">
      <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{titolo}}:</h5>
      <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
    </a>
    &nbsp;
    &nbsp;
    &nbsp;
    <a href="javascript:void(0)" class="d-flex align-items-center p-2 rounded-pill bg-light">
      <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Qty:</h5>
      <span class="badge badge-info badge-pill px-3 font-weight-bold font-14">{{totalQta}}</span>
    </a>
    &nbsp;
    &nbsp;
    &nbsp;
    <button type="button" class="btn btn-info rounded-pill py-2" (click)='ImportDaLavorare()'>
      <i class="fas fa-download font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Importa Lavorazioni</span>
    </button>

  </div>
  <div class="table-responsive">
    <table class="table bg-white table-hover align-middle mb-0 ">
      <thead>
        <tr>
          <th scope="col">
            <input type="checkbox" [(ngModel)]="isMasterSel" name="list_name" value="h1" (change)="checkUncheckAll()" />
          </th>
          <th scope="col">N.Ordine</th>
          <th>Prodotto</th>
          <th>Scheda di Lavorazione</th>
          <th>Distinta Base</th>
          <th scope="col">Quantità</th>
          <th scope="col" *ngIf="environment.ProdottiAddOn['taglie']">Taglia</th>
          <th scope="col">Lavorato</th>
          <th scope="col">Spedito</th>
          <th scope="col">Data Consegna</th>
          <th scope="col"><a href="javascript:void(0)" (click)='orderByData()'>Data Lavorazione</a></th>
          <th scope="col"><a href="javascript:void(0)" (click)='orderByNome()'>Cliente</a></th>

          <!--        <th scope="col" >Azioni</th>-->
        </tr>
      </thead>
      <tbody *ngFor="let elements of Lavorazioni | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <tr *ngFor="let item of elements.voci ">
          <td class="py-4">
            <input type="checkbox" [(ngModel)]="item.isSelected" name="list_name" (change)="isAllSelected()" />
          </td>
          <td class="align-middle">
            <span>
              <!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <!--              <i class="far fa-id-badge"></i>-->
              <!--            </span>-->
              {{ elements.codice}}
            </span>
          </td>
          <td class="align-middle">
            <span>
              <!--          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <!--            <i-feather name="info" class="feather-sm"></i-feather>-->
              <!--          </span>-->
              {{ item.voce }}
            </span>
          </td>
          <td class="align-middle">
            <span [class.text-danger]="!item.schedaLavorazione" [class.text-success]="item.schedaLavorazione">
              <i [class.far]="!item.schedaLavorazione" [class.fa-times-circle]="!item.schedaLavorazione"
                [class.fas]="item.schedaLavorazione" [class.fa-check-circle]="item.schedaLavorazione"></i>
            </span>
          </td>
          <td class="align-middle">
            <span [class.text-danger]="!item.distintaBase" [class.text-success]="item.distintaBase">
              <i [class.far]="!item.distintaBase" [class.fa-times-circle]="!item.distintaBase"
                [class.fas]="item.distintaBase" [class.fa-check-circle]="item.distintaBase"></i>
            </span>
          </td>
          <td class="align-middle">
            <span>
              <!--          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <!--            <i-feather name="list" class="feather-sm"></i-feather>-->
              <!--          </span>-->
              {{ item.quantita}}
            </span>
          </td>
          <td class="align-middle" *ngIf="environment.ProdottiAddOn['taglie']">
            <span>
              {{ item['tagliaObject']?.taglia}}
            </span>
          </td>
          <td class="align-middle">
            <span>
              <!--          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <!--            <i-feather name="list" class="feather-sm"></i-feather>-->
              <!--          </span>-->
              {{item.dataLavorato | date:"dd/MM/yyyy" }}
              <!--           <input type="checkbox" id="checkbox4" [disabled]="!item.modifica " [(ngModel)]="item.lavorato"> <label for="checkbox4"></label>-->
            </span>
          </td>
          <td class="align-middle">
            <span>
              <!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <!--              <i-feather name="send" class="feather-sm"></i-feather>-->
              <!--            </span>-->
              <!--            <input type="checkbox" id="spedito" [disabled]="!item.modifica " [(ngModel)]="item.spedito">-->
              <!--            <label for="spedito"></label>-->
              {{item.dataSpedizione | date:"dd/MM/yyyy" }}
            </span>
          </td>
          <td class="align-middle">
            <span>
              <!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <!--              <i class="fas fa-calendar"></i>-->
              <!--            </span>-->
              {{elements.data_consegna | date: "dd/MM/yyyy"}}
            </span>
          </td>
          <td class="align-middle">
            <span *ngIf="!item.modifica">
              <!--          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <!--            <i-feather name="calendar" class="feather-sm"></i-feather>-->
              <!--          </span>-->
              {{ item.dataLavorazione | date: "dd/MM/yyyy"}}
            </span>
            <span *ngIf="item.modifica ">
              <input [(ngModel)]="item.dataLavorazione" type="date" name="note" class="form-control">
            </span>
          </td>
          <td class="align-middle">
            <span>
              <!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <!--              <i class="fas fa-user"></i>-->
              <!--            </span>-->
              {{elements.clienteObject.nominativo || ""}}
            </span>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
    <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
      [collectionSize]="collectionSize" [pageSize]="pageSize">
    </ngb-pagination>
  </div>
</div>
<aside class="customizer">
  <div style="position: fixed; bottom: 20px; right: 10px;">
    <div class="d-md-flex align-items-center justify-content-end">
      <button *ngIf="daLavorare" type="submit" (click)="LavoraSelezionati()"
        class=" btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Lavora </span>
        <i-feather name="save" class="feather-sm "></i-feather>
      </button>
      <button *ngIf="Lavorati" type="submit" (click)="SpedisciSelezionati()"
        class=" btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Spedisci </span>
        <i-feather name="send" class="feather-sm "></i-feather>
      </button>
      <button *ngIf="inLavorazione" type="submit" (click)="LavoratoSelezionati()"
        class=" btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Lavorato </span>
        <i-feather name="save" class="feather-sm "></i-feather>
      </button>
      <button type="submit" (click)="StampaSelezionati()"
        class=" btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Stampa </span>
        <i-feather name="printer" class="feather-sm "></i-feather>
      </button>
      <button *ngIf="inLavorazione || Lavorati" type="submit" (click)="AnnullaSelezionati()"
        class=" btn btn-rounded btn-danger p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Annulla </span>
        <i-feather name="delete" class="feather-sm "></i-feather>
      </button>
    </div>
  </div>
</aside>